import defaultTheme from './defaultTheme';
const americanEagleTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#041c2c', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#041c2c', background: '#041c2c' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#041c2c' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#041c2c', border: '#041c2c', background: '#041c2c' }), field: {
        focus: '#041c2c',
        label: '#041c2c',
        icon: '#041c2c',
    } });
export default americanEagleTheme;
